module.exports = __webpack_public_path__ + "img/project3.aac8cb3d.png";